import Backbone from 'backbone';

import Slice from 'molbio/maps/linear/Slice';

class Slices extends Backbone.Collection<Slice> {
  static initClass(): void {
    this.prototype.model = Slice;
  }
}
Slices.initClass();

export default Slices;
